export const PROGRAM_SERIES = {
  programTitle: 'AI-Native Software Engineering Program',
  programDetailPath: '/programs/ai-engineer',
  programsListPath: '/programs',
  interviewsPath: '/interviews',
  navPrograms: 'IDC Academy',
  navInterview: 'Interviews',
  programsHeroTitle: 'Find the engineering program that matches your next step.',
  programsHeroIntro:
    'Explore our Guided industry-focused programs designed around modern software engineering, cloud, Generative AI, and system design — and apply to the one that best matches your goals.',
  ctaExploreProgram: 'Explore the Program',
  enrollmentCourseTitle: 'Build Core Engineering & AI Skills',
  enrollmentCourseShort: 'Core Engineering & AI Foundations',
  enrollmentNote:
    'Enrollment is open for Build Core Engineering & AI Skills — Course 1 of 4 in the AI-Native Software Engineer Program.',
  seriesLabel: '4-course engineering series',
  eligibility:
    'Anyone with programming basics can apply.',
  mentoring: {
    title: 'Mentoring',
    cadence: 'Throughout the program',
    description:
      'Industry mentors review how you design, build, and communicate — not only whether the code runs. Reviews continue across the program, not as a one-off checkpoint.',
  },
  assessmentBenefit: {
    title: 'Scholarship Exam & Expert Interview',
    intro:
      'After you apply, take the scholarship exam and attend a one-on-one expert interview to qualify for fee support.',
    examStep: {
      title: 'Scholarship Exam',
      description:
        'A focused assessment of your fundamentals, logical thinking, and readiness for an intensive engineering program.',
    },
    interviewStep: {
      title: 'Expert Interview',
      description:
        'A one-on-one discussion with an industry expert on problem-solving, technical depth, and systems thinking — with personalized feedback.',
    },
    scholarshipIntro: 'Strong performance in these assessments can earn you a scholarship of',
    scholarshipHighlight: 'up to 100%',
    scholarshipOutro: 'of the program fee.',
    heroLinkTeaser:
      'Scholarship exam + expert interview — qualify for up to 100% scholarship on the program fee.',
    feeCardNote: 'Up to 100% off based on assessments',
    stickyBarNote: 'Up to 100% off based on assessments',
    finalCtaNote:
      'Apply to take the scholarship exam and meet an industry expert — qualify for up to 100% scholarship on the program fee.',
  },
  courses: [
    {
      id: 'course-1',
      label: 'Course 1 of 4',
      title: 'Build Core Engineering & AI Skills',
      description: 'Current intake — programming, APIs, cloud basics, DevOps foundations, and AI-assisted engineering.',
      isCurrent: true,
    },
    {
      id: 'course-2',
      label: 'Course 2 of 4',
      title: 'Modern Backend + Cloud Engineering',
      description:
        'Advanced C#, Advanced Python, Cloud Native APIs, Security Engineering, Observability Foundations, Team Project.',
      isCurrent: false,
    },
    {
      id: 'course-3',
      label: 'Course 3 of 4',
      title: 'System Design + DevOps + Production Engineering',
      description: 'Scalable architecture, CI/CD, production operations, and reliability practices.',
      isCurrent: false,
    },
    {
      id: 'course-4',
      label: 'Course 4 of 4',
      title: 'AI-Native Product Engineering',
      description: 'Build and ship AI-native products with modern cloud and product engineering workflows.',
      isCurrent: false,
    },
  ],
  finalOutcomes: [
    { level: 'Beginner', outcome: 'Can build applications independently.' },
    { level: 'Level 1', outcome: 'Can build production-grade backend systems.' },
    { level: 'Level 2', outcome: 'Can design scalable distributed systems.' },
    {
      level: 'Level 3',
      outcome: 'Can build AI-native cloud products and lead engineering discussions.',
    },
  ],
  industryRoles: [
    'Backend Engineer',
    'Full Stack Engineer',
    'Cloud Engineer',
    'DevOps Engineer',
    'Platform Engineer',
    'Production Engineer',
    'AI Product Engineer',
  ],
  notOnly: ['only coding', 'only cloud', 'only AI', 'only DevOps'],
  creates: [
    'Product-minded',
    'AI-native',
    'Production-aware',
    'Cloud-ready engineers capable of building real systems.',
  ],
  differentiatorQuote: {
    intro: 'The biggest differentiator in 2026 is no longer:',
    oldQuestion: '“Can you code?”',
    newQuestion:
      '“Can you build, deploy, scale, observe, secure, and evolve real products using AI effectively?”',
    closing: 'That’s the foundation of this roadmap.',
  },
  evaluationBasedOn: [
    'Projects',
    'Architecture discussions',
    'Code reviews',
    'Production readiness',
    'GitHub contributions',
  ],
  evaluationNot: ['theory exams'],
  contentDisclaimer:
    'IDCoder reserves the right to update or modify course content, structure, and delivery as required to maintain industry relevance and program quality.',
} as const;
